import React from "react";
import { geDepositStatusClassName } from "../../helpers/StatusHelpers";
export const depositsColumns = [
  { name: "id", title: "ID", sortable: true },
  { title: "USER", sortable: true, template: (d) => d.user.username },

  { name: "amount", title: "AMOUNT", sortable: true },
  // { name: "fees", title: "FEES", sortable: true },
  {
    template: (d) => (
      <span className={geDepositStatusClassName(d.status)}>{d.status}</span>
    ),
    title: "STATUS",
    sortable: true,
  },
  {
    template: (d) => d.payment_method.name,
    title: "PAYMENT_METHOD",
    sortable: true,
  },
  { name: "receipt_number", title: "RECEIPT", sortable: true },
  {
    template: (d) => {
      return (
        <a
          href={
            process.env.REACT_APP_API_URL +
            "/storage/payment_receipts/" +
            d.payment_receipt
          }
          download
          target="_blank"
          rel="noopener noreferrer"
        >
          receipt
        </a>
        // <picture>
        //   <source
        //     srcSet={
        //       process.env.REACT_APP_API_URL +
        //       "/storage/payment_receipts/" +
        //       d.payment_receipt
        //     }
        //   />
        //   <img
        //     src={
        //       process.env.REACT_APP_API_URL +
        //       "/storage/payment_receipts/" +
        //       d.payment_receipt
        //     }
        //     alt=""
        //   />
        // </picture>
      );
    },
    title: "PAYMENT_RECEIPT",
    sortable: false,
  },
  { name: "created_at", title: "CREATED_AT", sortable: true, type: "date" },
  { name: "updated_at", title: "UPDATED_AT", sortable: true, type: "date" },
];
